module.exports = __webpack_public_path__ + "img/pumping-activities-role2.d850144c.png";